// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/trash.js';

import { paths } from '../generated/trash';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('trash', Original, paths);
